import React from 'react'
import images from 'assets/images'
import Button from 'components/Button'
import styles from './DeveloperHubNew.module.scss'

const arrBannerInfo = [
  {
    icon: 'icon-icon-launch',
    text: 'Proof of Stake Voting (PoSV)',
  },
  {
    icon: 'icon-icon-money',
    text: 'Zero Gas Fee',
  },
  {
    icon: 'icon-icon-global',
    text: 'EVM - compatible',
  },
]

const arrContentHub = [
  {
    title: 'Build Dapp on Viction',
    content: [
      {
        subTitle: 'Walkthrough: Build a Dapp on Viction',
        link: 'https://docs.viction.xyz/developer-guide/build-a-dapp-on-viction',
      },
      {
        subTitle: 'Data and analytics',
        link: 'https://docs.viction.xyz/developer-guide/data-and-analytics',
      },
      {
        subTitle: 'Embedded Wallet (MPC)',
        link: 'https://docs.viction.xyz/developer-guide/embedded-wallet-mpc',
      },
      {
        subTitle: 'Integration',
        link: 'https://docs.viction.xyz/developer-guide/integration',
      },
    ],
  },
  {
    title: 'Smart Contract Development',
    content: [
      {
        subTitle: 'Solidity',
        link: 'https://docs.viction.xyz/smart-contract-development/solidity',
      },
      {
        subTitle: 'Standards & Specification',
        link: 'https://docs.viction.xyz/smart-contract-development/standards-and-specification',
      },
      {
        subTitle: 'IDEs and Tools',
        link: 'https://docs.viction.xyz/smart-contract-development/ides-and-tools',
      },
      {
        subTitle: 'Deployment & Verification',
        link: 'https://docs.viction.xyz/smart-contract-development/smart-contract-verification',
      },
    ],
  },
]

const arrTutorials = [
  {
    icon: images.iconConnect,
    description: 'How to connect to Viction Blockchain',
    link: 'https://docs.viction.xyz/how-to/how-to-connect-to-viction-network',
  },
  {
    icon: images.iconStake,
    description: 'Staking and Governance',
    link: 'https://docs.viction.xyz/developer-guide/integration/vic-zerogas-integration',
  },
  {
    icon: images.iconGas,
    description: 'How to enable zero-gas transaction',
    link: 'https://docs.viction.xyz/developer-guide/integration/vic-zerogas-integration',
  },
  {
    icon: images.iconTele,
    description: 'How to create Telegram Mini Apps',
    link: 'https://docs.viction.xyz/how-to/how-to-create-telegram-mini-apps',
  },
  {
    icon: images.iconBlock,
    description: 'How to enable Verified Random Function (VRF)',
    link: 'https://docs.viction.xyz/developer-guide/integration/vrrf',
  },
]

const arrFaqs = [
  {
    icon: images.iconFile,
    text: 'Whitepaper',
    link: 'https://docs.viction.xyz/whitepaper-and-research',
  },
  {
    icon: images.iconMasterNode,
    text: 'MasterNode',
    link: 'https://docs.viction.xyz/masternode',
  },
  {
    icon: images.iconSquare,
    text: "How to troubleshoot when the node is up but couldn't begin to sync block",
    link: 'https://docs.viction.xyz/how-to/how-to-troubleshoot-when-the-node-is-up-but-couldnt-begin-to-sync-block',
  },
]

const arrEvents = [
  {
    thumbnail: images.bannerEvent1,
    title: 'Viction Hackathon',
    description:
      'Viction Horizon is a startup hackathon designed for developers, creators, innovators, and visionaries around the globe.',
    textLink: 'Explore Viction Horizon',
    link: 'https://horizon.viction.xyz/',
  },
  {
    thumbnail: images.bannerEvent2,
    title: 'Viction Game Awards 2025',
    description:
      'Viction Game Awards 2025 is a celebration of the best games built on the Viction platform.',
    textLink: 'Explore Viction Game Awards',
    link: 'https://gameawards.viction.xyz/',
  },
]

const arrSupports = [
  {
    icon: images.iconDiscord,
    title: 'Discord',
    description:
      'Join our Discord for fast help, troubleshooting, and community solutions.',
    link: 'https://viction.link/discord',
  },
  {
    icon: images.iconGmail,
    title: 'Gmail',
    description:
      'Email us to get detailed assistance and solutions for your queries.',
    link: 'mailto:support@viction.xyz',
  },
  {
    icon: images.iconViction,
    title: 'Forum',
    description:
      'Connect with experts and the community for all your technical needs.',
    link: 'https://forum.viction.xyz/',
  },
]

const arrBuild = [
  {
    name: 'Data Indexing & Onchain Analytics',
    logos: [
      {
        icon: images.buildIcon1,
        link: 'https://dune.com/',
      },
      {
        icon: images.buildIcon2,
        link: 'https://www.nansen.ai/',
      },
      {
        icon: images.buildIcon3,
        link: 'https://tokenterminal.com/',
      },
      {
        icon: images.buildIcon4,
        link: 'https://thegraph.com/',
      },
      {
        icon: images.buildIcon5,
        link: 'https://dappradar.com/',
      },
    ],
  },
  {
    name: 'RPC, Node & Infra Providers',
    logos: [
      {
        icon: images.buildIcon6,
        link: 'https://drpc.org/',
      },
      {
        icon: images.buildIcon7,
        link: 'https://blockpi.io/',
      },
      {
        icon: images.buildIcon8,
        link: 'https://nirvanalabs.io/',
      },
    ],
  },
  {
    name: 'Smart Contract Deployment & Customization',
    logos: [
      {
        icon: images.buildIcon9,
        link: 'https://thirdweb.com/',
      },
      {
        icon: images.buildIcon10,
        link: 'https://forwardprotocol.io/',
      },
      {
        icon: images.buildIcon11,
        link: 'https://www.privy.io/',
      },
    ],
  },
  {
    name: 'Oracles & Real-time Data',
    logos: [
      {
        icon: images.buildIcon12,
        link: 'https://pyth.network/',
      },
      {
        icon: images.buildIcon13,
        link: 'https://www.stork.network/',
      },
    ],
  },
  {
    name: 'Governance & DAO Tools',
    logos: [
      {
        icon: images.buildIcon14,
        link: 'https://www.tally.xyz/',
      },
    ],
  },
  {
    name: 'Security, Access & Identity',
    logos: [
      {
        icon: images.buildIcon15,
        link: 'https://revoke.cash/',
      },
      {
        icon: images.buildIcon16,
        link: 'https://d3.inc/',
      },
      {
        icon: images.buildIcon17,
        link: 'https://www.oneid.xyz/',
      },
      {
        icon: images.buildIcon18,
        link: 'https://chainlyze.ai/',
      },
      {
        icon: images.buildIcon19,
        link: 'https://www.nftscan.com/',
      },
    ],
  },
  {
    name: 'Wallet',
    logos: [
      {
        icon: images.buildIcon20,
        link: 'https://coin98.com/',
      },
      {
        icon: images.buildIcon26,
        link: 'https://docs.coin98.com/developer-guide/coin98-adapter',
      },
      {
        icon: images.buildIcon21,
        link: 'https://www.ramper.xyz/',
      },
      {
        icon: images.buildIcon22,
        link: 'https://reown.com/blog/how-to-get-started-with-reown-appkit-on-viction',
      },
      {
        icon: images.buildIcon23,
        link: 'https://particle.network/',
      },
      {
        icon: images.buildIcon24,
        link: 'https://www.privy.io/',
      },
      {
        icon: images.buildIcon25,
        link: 'https://rabbitswap.xyz',
      },
    ],
  },
]

function DeveloperHubNew() {
  return (
    <div className={styles.hubNew}>
      <div className='hub-new-wrapper'>
        <div className='hub-new-banner'>
          <div className='hub-new-banner-container'>
            <div className='hub-banner-content'>
              <div className='banner-left'>
                <h1 className='banner-left--title'>
                  A Blockchain For User-First Builders
                </h1>

                <div className='banner-left--description'>
                  We empower builders from all walks of life to build fast,
                  scale easily, and onboard users frictionlessly.
                </div>

                <div className='btn-doc'>
                  <a
                    href='https://docs.viction.xyz'
                    target='_blank'
                    rel='noreferrer'>
                    <Button variant='secondary'>
                      Read Docs{' '}
                      <span className='icon-web_arrow_up_right arrow-icon'></span>
                    </Button>
                  </a>
                </div>

                <div className='hub-banner-info'>
                  {arrBannerInfo.map((item, i) => {
                    return (
                      <div className='banner-info-item' key={i}>
                        <span className={`icon ${item.icon} item-icon`}></span>

                        <div className='info-item-text'>{item.text}</div>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className='banner-right'>
                <img src={images.hubBanner} alt='' className='img-banner' />
              </div>
            </div>
          </div>
        </div>

        <div className='hub-new-content-wrapper'>
          <img src={images.curveUpBlack2} alt='' className='img-curve-up' />

          <div className='hub-new-content-container'>
            {arrContentHub.map((item, i) => {
              return (
                <div className='hub-new-content' key={i}>
                  <div className='content-title'>{item.title}</div>

                  <div className='content-detail'>
                    {item.content.map((itemChild, index) => {
                      return (
                        <div className='content-detail-item' key={index}>
                          <div className='content-detail-item--title'>
                            {itemChild.subTitle}
                          </div>

                          <div className='content-detail-item--more'>
                            <a
                              href={itemChild.link}
                              target='_blank'
                              rel='noreferrer'>
                              <div className='read-more text-hover-underline-white'>
                                Read Docs
                              </div>
                            </a>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>

          <div className='content-tutorial-wrapper'>
            <img src={images.curveBorder} alt='' className='img-curve-border' />

            <div className='content-tutorial-container'>
              <div className='content-tutorial-title'>Tutorial</div>

              <div className='content-tutorial-detail'>
                {arrTutorials.map((item, i) => {
                  return (
                    <div className='tutorial-detail-item' key={i}>
                      <div className='item-icon'>
                        <img src={item.icon} alt='' className='img-icon' />
                      </div>

                      <div className='item-info'>
                        <div className='item-info--description'>
                          {item.description}
                        </div>

                        <div className='item-info--link'>
                          <a href={item.link} target='_blank' rel='noreferrer'>
                            <div className='text-link text-hover-underline-white'>
                              Read Docs
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>

        <div className='hub-section'>
          <div className='hub-faq-wrapper'>
            <div className='hub-faq-container'>
              <div className='hub-faq-title'>Resource & FAQ</div>

              <div className='hub-faq-content'>
                {arrFaqs.map((item, i) => {
                  return (
                    <div className='faq-item' key={i}>
                      <div className='faq-info'>
                        <div className='faq-info--icon'>
                          <img src={item.icon} alt='' className='img-icon' />
                        </div>

                        <div className='faq-info--text'>{item.text}</div>
                      </div>

                      <div className='faq-link'>
                        <a href={item.link} target='_blank' rel='noreferrer'>
                          <div className='text-link text-hover-underline-yellow'>
                            Read Docs
                          </div>
                        </a>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className='hub-event-wrapper'>
            <div className='hub-event-container'>
              <div className='hub-event-title'>
                <div className='title-text'>Events for Developers</div>

                {/* <div className='title-action'>
                  <Button variant='secondary'>
                    All events{' '}
                    <span className='icon-web_arrow_up_right icon-action'></span>
                  </Button>
                </div> */}
              </div>

              <div className='hub-event-content'>
                {arrEvents.map((item, i) => {
                  return (
                    <div className='event-item' key={i}>
                      <div className='event-item__thumbnail'>
                        <img
                          src={item.thumbnail}
                          alt=''
                          className='img-thumbnail'
                        />
                      </div>

                      <div className='event-item__info'>
                        <div className='info-title'>{item.title}</div>
                        <div className='info-description'>
                          {item.description}
                        </div>
                        <div className='info-link'>
                          <a href={item.link} target='_blank' rel='noreferrer'>
                            <div className='text-link text-hover-underline'>
                              {item.textLink}
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className='hub-support'>
            <div className='hub-support-container'>
              <div className='support-title'>Technical Support</div>

              <div className='support-content'>
                {arrSupports.map((item, i) => {
                  return (
                    <div className='support-content-item' key={i}>
                      <div className='icon-content'>
                        <img src={item.icon} alt='' className='img-icon' />
                      </div>

                      <div className='text-content'>
                        <div className='text-content--title'>
                          <a href={item.link} target='_blank' rel='noreferrer'>
                            {item.title}
                          </a>
                        </div>
                        <div className='text-content--description'>
                          {item.description}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            <img src={images.curveGrey} alt='' className='img-curve-grey' />
          </div>
        </div>

        <div className='hub-build'>
          <div className='hub-build-container'>
            <div className='hub-build-title'>
              Build faster <br /> with tools that matter
            </div>

            <div className='hub-build-content'>
              {arrBuild.map((item, i) => {
                return (
                  <div className='build-item' key={i}>
                    <div className='build-item__name'>{item.name}</div>

                    <div className='build-item__logo'>
                      {item.logos.map((logo, index) => {
                        return (
                          <a href={logo.link} target='_blank' rel='noreferrer'>
                            <img
                              src={logo.icon}
                              alt=''
                              className='img-logo'
                              key={index}
                            />
                          </a>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>

            <div className='hub-build-link'>
              <a
                href='https://viction.xyz/ecosystem'
                target='_blank'
                rel='noreferrer'>
                <div className='link-text text-hover-underline'>
                  Explore all Tools, Applications & Infrastructure on Viction
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeveloperHubNew
